// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import { useCallback } from 'react';
import { useAppSelector } from 'Hooks';
import { findFolderById, selectFolderList } from 'Features/folderList/folderListSelector';

// AUT-6432: which folder the map's surfaces name on a project. The rail's cards and the pin
// card both badge it, and both drop it while the map is scoped to one folder - every project
// on screen is in that folder then, and the breadcrumb already says so. One resolver so the
// two cannot disagree about the same project.
//
// Returns a resolver rather than a name because the rail asks for many projects per render;
// stable until the folder list or the scope changes, so memoised cards keep their memo.
export const useMapFolderBadgeName = () => {
  const folderList = useAppSelector(selectFolderList);
  const mapFolderId = useAppSelector((state) => state.projectList.mapFolderId);

  return useCallback((folderId?: string | null): string | undefined => (
    mapFolderId ? undefined : findFolderById(folderList, folderId || undefined)?.name
  ), [folderList, mapFolderId]);
};

export default useMapFolderBadgeName;
